import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['cv', 'cover', 'other']),
  mime: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  file_name: PropTypes.string,
  created_at: PropTypes.string,
  updated_at: PropTypes.string,
};

export const defaultProps = {
  id: null,
  type: 'cv',
  mime: '',
  size: 0,
  title: '',
  file_name: '',
  created_at: null,
  updated_at: null,
};

export default { defaultProps, propTypes };
